const sessionKey = (reservationId: string) => `rf_${reservationId}`;

export interface PersistedSession {
  formValues: Record<string, any>;
  ticketPersonData: Record<number, Record<string, string | null>>;
  // productId -> optionId -> quantity
  optionQuantities?: Record<number, Record<number, number>>;
  // productId -> ticketId -> optionId -> quantity
  ticketOptionQuantities?: Record<number, Record<number, Record<number, number>>>;
  selectedTicketIds?: number[];
}

export function saveFormSession(
  reservationId: string,
  data: PersistedSession,
): void {
  try {
    sessionStorage.setItem(sessionKey(reservationId), JSON.stringify(data));
  } catch {}
}

export function loadFormSession(
  reservationId: string,
): PersistedSession | null {
  try {
    const raw = sessionStorage.getItem(sessionKey(reservationId));
    return raw ? (JSON.parse(raw) as PersistedSession) : null;
  } catch {
    return null;
  }
}

export function clearFormSession(reservationId: string): void {
  try {
    sessionStorage.removeItem(sessionKey(reservationId));
  } catch {}
}
